import { useEffect, useState } from "react";
import { api } from "../lib/api";
import AppShell from "../components/AppShell";
import { FUNDER_NAV } from "./FunderTerminal";

export default function FunderAnalytics() {
  const [a, setA] = useState(null);
  useEffect(() => { (async()=>{ const r = await api.get("/funder/analytics"); setA(r.data); })(); }, []);
  if (!a) return <AppShell nav={FUNDER_NAV}>Loading…</AppShell>;
  const max = Math.max(1, ...a.by_sector.map(s=>s.count));
  return (
    <AppShell nav={FUNDER_NAV}>
      <h1 className="text-3xl font-bold text-neutral-900">Cohort & benchmark analytics</h1>
      <p className="mt-1 text-sm text-neutral-600">Real-time pipeline view across sectors, countries and readiness.</p>

      <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
        <Stat label="Verified SMEs" value={a.verified}/>
        <Stat label="Total SMEs in pipeline" value={a.total_smes}/>
        <Stat label="Average readiness" value={`${a.avg_score} / 100`}/>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-5 lg:grid-cols-2">
        <div className="rounded-2xl border border-neutral-200 bg-white p-6" data-testid="by-sector">
          <p className="text-xs font-bold uppercase tracking-wider text-neutral-500">By sector</p>
          <ul className="mt-4 space-y-3">
            {a.by_sector.map(s => (
              <li key={s.sector}>
                <div className="flex items-baseline justify-between text-sm"><span className="font-semibold text-neutral-900">{s.sector || "—"}</span><span className="text-neutral-500">{s.count} · avg {s.avg_score}</span></div>
                <div className="mt-1 h-2 rounded-full bg-neutral-100"><div className="h-2 rounded-full bg-[#0A8B85]" style={{width: `${(s.count/max)*100}%`}}/></div>
              </li>
            ))}
          </ul>
        </div>
        <div className="rounded-2xl border border-neutral-200 bg-white p-6" data-testid="by-country">
          <p className="text-xs font-bold uppercase tracking-wider text-neutral-500">By country</p>
          <ul className="mt-4 space-y-3">
            {a.by_country.map(c => (
              <li key={c.country} className="flex items-center justify-between text-sm">
                <span className="font-semibold text-neutral-900">{c.country || "—"}</span>
                <span className="text-neutral-500">{c.count} SMEs · avg {c.avg_score}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </AppShell>
  );
}
const Stat = ({label, value}) => (
  <div className="rounded-2xl border border-neutral-200 bg-white p-6">
    <p className="text-xs font-bold uppercase tracking-wider text-neutral-500">{label}</p>
    <p className="mt-2 text-3xl font-extrabold text-[#0A8B85]">{value}</p>
  </div>
);
